<template>
  <p class="font-weight-bold mb-3">
    For more information, please send us an
    <a :href="`mailto:${infoEmail}?subject=${subject}`" class="text-primary"
      >email</a
    >
    with:
  </p>
  <ol class="text-body-1 ml-6">
    <li>A photo of your whole vehicle</li>
    <li>A close-up photo of the damaged area</li>
    <li>A description of the damaged area</li>
    <li>Your vehicle’s year, make, model and VIN</li>
    <li>Your contact info, and the best time you can be reached</li>
  </ol>
</template>

<script setup lang="ts">
const infoEmail = import.meta.env.VITE_EMAIL

defineProps({
  subject: {
    default: 'Auto body repair, paint and refinish inquiry',
    type: String
  }
})
</script>
